/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import DeliveryListColumnOption from './DeliveryListColumnOption';

/**
* The GetCompanyConfigResponse model module.
* @module model/GetCompanyConfigResponse
* @version 2020-12-7
*/
export default class GetCompanyConfigResponse {
    /**
    * Constructs a new <code>GetCompanyConfigResponse</code>.
    * 会社のコンフィグレクエスト
    * @alias module:model/GetCompanyConfigResponse
    * @class
    * @param candidates {Array.<module:model/DeliveryListColumnOption>} フィールド
    * @param order {Array.<Number>} オーダー
    * @param result {module:model/GetCompanyConfigResponse.ResultEnum} 
    */

    constructor(candidates, order, result) {
        
        
        this['candidates'] = candidates;
        this['order'] = order;
        this['result'] = result;
        
    }

    /**
    * Constructs a <code>GetCompanyConfigResponse</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/GetCompanyConfigResponse} obj Optional instance to populate.
    * @return {module:model/GetCompanyConfigResponse} The populated <code>GetCompanyConfigResponse</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new GetCompanyConfigResponse();
                        
            
            if (data.hasOwnProperty('candidates')) {
                obj['candidates'] = ApiClient.convertToType(data['candidates'], [DeliveryListColumnOption]);
            }
            if (data.hasOwnProperty('order')) {
                obj['order'] = ApiClient.convertToType(data['order'], ['Number']);
            }
            if (data.hasOwnProperty('result')) {
                obj['result'] = ApiClient.convertToType(data['result'], 'String');
            }
        }
        return obj;
    }

    /**
    * フィールド
    * @member {Array.<module:model/DeliveryListColumnOption>} candidates
    */
    'candidates' = undefined;
    /**
    * オーダー
    * @member {Array.<Number>} order
    */
    'order' = undefined;
    /**
    * @member {module:model/GetCompanyConfigResponse.ResultEnum} result
    */
    'result' = undefined;



    /**
    * Allowed values for the <code>result</code> property.
    * @enum {String}
    * @readonly
    */
    static ResultEnum = {
        /**
         * value: "NG"
         * @const
         */
        "NG": "NG",
        /**
         * value: "OK"
         * @const
         */
        "OK": "OK"    };

}
